import Box from '@mui/material/Box';
import AppPageHeaderText from './text/AppPageHeaderText';
import AppPageHeaderDescription from './text/AppPageHeaderDescription';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ControlsDialog } from './filters/ControlsDialog';
import PropTypes from 'prop-types';

/** @component
 * Renders the app page header.
 * @param ebabPeriod {string} the ebab period.
 * @returns {JSX.Element}
 * @constructor
 */
const AppPageHeader = ({ ebabPeriod }) => {
    const theme = useTheme();
    const isBelowSm = useMediaQuery(theme.breakpoints.down('sm'));
    const isBelowMd = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box
            display='flex'
            flexDirection='column'
            justifyContent='space-between'
            data-analyticsid='app-header'
        >
            <Box
                sx={{
                    flexGrow: 1,
                    margin: 'auto'
                }}
            >
                <AppPageHeaderText id={'appPageHeaderText'} />
                {!isBelowSm && (
                    <AppPageHeaderDescription
                        id={'appPageDescription'}
                        ebabPeriod={ebabPeriod}
                    />
                )}
            </Box>
            {isBelowMd && (
                //Filter button has fixed display on mobiles and displays relative to typography on small screens
                <Box
                    sx={{
                        alignSelf: 'flex-end',
                        marginRight: 2,
                        position: 'absolute',
                        visible: false,
                        zIndex: 10
                    }}
                >
                    <ControlsDialog />
                </Box>
            )}
        </Box>
    );
};

AppPageHeader.propTypes = {
    ebabPeriod: PropTypes.string
};

export default AppPageHeader;
